<template>
  <div class="notif-menu">
    <b-dropdown id="dropdownNotif" no-caret class="dropdown-notif" right>
      <template slot="button-content">
        <a @click="registerVisualizationLastNotifications(lastNotificationsIds)" class="nav-link sino-menu" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="far fa-bell"></i><i class="fas" :class="circleClass"></i></a>
      </template>
      <p class="pl-4">Notificações</p>
      <div class="dropdown-divider"></div>
      <a v-for="notif in lastNotifications" :key="notif.id" @click="registerAccess(notif.id)" class="dropdown-item" :class="notif.tipo_notificacao.categoria" :href="notif.url" target="_blank">
        <div class="d-flex align-items-center">
          <div class="text-center">
            <i class="fas" :class="notif.tipo_notificacao.icone"></i>
          </div>
          <div>
            <span>{{ notif.tipo_notificacao.descricao }}</span>
            <p>{{ notif.notificacao }}</p>
            <p>{{ days(notif.created_at) }}</p>
          </div>
        </div>
        <div class="dropdown-divider"></div>
      </a>
      <a href="/notificacoes">Ver todas</a>
    </b-dropdown>
  </div>
</template>

<script>
import DateUtils from '@/core/utils/date-utils'
import { mapState } from 'vuex'
import $ from 'jquery'

export default {
  name: 'Notifications',
  data () {
    return {
      notif: null
    }
  },
  computed: {
    ...mapState({
      notifications: (state) => state.notification.notifications
    }),
    newNotification () {
      let newNotification = this.notifications.nova_notificacao
      return newNotification
    },
    lastNotifications () {
      let data = {}
      let lastNotifications = {}
      if (typeof this.notifications.data !== 'undefined' && this.notifications.data !== null){
        data = this.notifications.data
        if (data.length >= 3){
          lastNotifications = data.slice(0, 3)
        }
      }
      return lastNotifications
    },
    lastNotificationsIds () {
      let lastNotificationsIds = this.lastNotifications.map(item => item.id)
      return lastNotificationsIds
    },
    circleClass () {
      return this.notifications.nova_notificacao ? 'fa-circle' : null
    }
  },
  methods: {
    registerVisualizationLastNotifications () {
      this.$store.dispatch('registerVisualization', this.lastNotificationsIds)
      let dropdown = $('.dropdownMenu')
      dropdown.show()
    },
    registerAccess (id) {
      this.$store.dispatch('registerAccess', id)
    },
    days (createdAt) {
      return DateUtils.daysAgo(createdAt)
    }
  }
}
</script>
